import { Action } from 'redux';
import { generalActions } from './general.slice';

export const APP_START = 'APP_START';

export const {
  setIsAppInitialized,
  addLoaderFullPage,
  removeLoaderFullPage,
  setCurrentOrderId,
  addRouteToHistory,
  removeLastRouteFromHistory,
  replaceLastRouteFromHistory,
  setOperation,
  setErrorDescription,
} = generalActions;

export const appStart: Action<typeof APP_START> = { type: APP_START };
